import { Box, Grid, Typography } from "@material-ui/core"
import { PlanningItemsSummaryTimeline } from "../overview/planning-items-summary-timeline";
import { useTranslation } from "react-i18next";

export const RouteOverviewNavigatorView = ({ routePlans }) => {
    const { t } = useTranslation();

    return (
        <Box my={5}>
            <Grid container>
                {
                    routePlans?.length > 0 ? 
                        <Grid item xs={12}>
                            {routePlans.map(routePlan => <PlanningItemsSummaryTimeline 
                                key={routePlan.id} route={routePlan.route} planningItems={routePlan.items} />)}
                        </Grid> : 
                        <Grid item xs={12}>
                            <Typography align="center">{t('NoData')}</Typography>
                        </Grid>
                }
            </Grid>
        </Box>
    );

}